import React, {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";


import {
    StyleSheet,
    Text,
    View,
} from "react-native";
import {Button} from "../../../components/core/Button";
import {globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {isMobile, trackMoengageEvent} from "../../../utils/commonMethods";

import {globalImport} from "../../../common/globalImports";
import OTPTextView from "../../../commonComponents/OtpComp";
import useTimer from "../../../commonComponents/useTimer";
import {Network} from "../../../utils/network";
import ShowError from "../../../common/ShowError";
import {getUser} from "../redux/profile.action";
import {useDispatch} from "react-redux";

function EmailBottomSheet({mobileEmailSheet, email, setMobileEmailSheet}) {

    const dispatch = useDispatch();
    const [error, setError] = useState(null);
    const [otpbox, setOtpBox] = useState("");
    const [isLoginBtnValid, setIsLoginBtnValid] = useState(false);
    // const [resendEnabled, setResendEnabled] = useState(true);

    // const [seconds, resetTimer] = useTimer(30);

    const onFormSubmit = async (data) => {
        const inputData = {
            email,
            otp: otpbox,
        };
        trackMoengageEvent("Verify OTP Email Click", {
            Email: email,
            OTP: otpbox,
        });
        const res = await Network.verifyEmailOtp(inputData);
        if (!res?.data?.verified) {
            setError({
                val: "Retry",
                message: res?.data?.msg,
                errorClass: { color: Colors.red },
                borderColor: Colors.red
            });
        } else {
            setError({
                val: "Applied",
                message: res?.data?.msg,
                errorClass: { color: Colors.green },
                borderColor: Colors.green
            });
            await dispatch(getUser());
            setMobileEmailSheet(false);
        }
    };
    const handleChange = (otp) => {
        if (otp.length === 4) {
            setIsLoginBtnValid(true);
        } else {
            setIsLoginBtnValid(false);
        }
        setOtpBox(otp);
    };

    // const onResend = () => {
    //     setResendEnabled(false);
    //     // onOTPSubmit(null, true);
    // };

    return (
        <View
            style={{
                paddingTop: 20,
                height: "100%",
            }}>
            <View style={{paddingHorizontal: 16}}>
                <Text
                    style={{
                        ...globalFontStyle.appFontTitle,
                        color: Colors?.black,
                        paddingBottom: 5,
                    }}>
                    { "OTP Verification"}
                </Text>
                {/*{showMobVerify !== 'Add Funds' && (*/}
                <Text
                    style={{
                        ...globalFontStyle.appFontHeadingRegular,
                        color: Colors?.lightgrey,
                        paddingBottom: 25,
                    }}>
                    {mobileEmailSheet === 'email'
                        ? "Otp has been sent to your email. Please enter the same to confirm."
                        : "Otp has been sent to your number. Please enter the same to confirm."}
                </Text>
                {/*)}*/}
                <OTPTextView
                    containerStyle={{
                        justifyContent: "flex-start",
                        width: "100%",
                        height: 60,
                        marginVertical: 0
                    }}
                    handleTextChange={(text) => handleChange(text)}
                    inputCount={4}
                    keyboardType="numeric"
                    textInputStyle={styles.underlineStyleBase}
                    offTintColor={error ? error?.borderColor : "#BDBDBD"}
                    tintColor={error ? error?.borderColor : Colors.black}
                    autoFocus={false}
                />
                <View>
                    {error !== null && error?.message !== "" && (
                        <ShowError error={error} />
                    )}
                    {/*{resendEnabled && (<>*/}
                    {/*    {seconds !== 0 ? (*/}
                    {/*        <View style={{ flexDirection: "row", paddingTop: 20 }}>*/}
                    {/*            <Text*/}
                    {/*                style={{*/}
                    {/*                    ...globalFontStyle.appFontSmallText,*/}
                    {/*                    color: Colors.lightgrey,*/}
                    {/*                }}*/}
                    {/*            >*/}
                    {/*                {seconds !== 0*/}
                    {/*                    ? `Resend OTP in ${seconds} seconds`*/}
                    {/*                    : "Didn’t received?"}*/}
                    {/*            </Text>*/}
                    {/*            <View style={{ flex: 1 }} />*/}
                    {/*        </View>*/}
                    {/*    ) : (*/}
                    {/*        <View style={{ flexDirection: "row", paddingTop: 20 }}>*/}
                    {/*            <Text*/}
                    {/*                style={{*/}
                    {/*                    ...globalFontStyle.appFontSmallText,*/}
                    {/*                    color: Colors.black,*/}
                    {/*                    borderBottomWidth: 2,*/}
                    {/*                    borderBottomColor: Colors.black,*/}
                    {/*                }}*/}
                    {/*                onPress={onResend}*/}
                    {/*            >*/}
                    {/*                {" "}*/}
                    {/*                Resend OTP*/}
                    {/*            </Text>*/}
                    {/*            <View style={{ flex: 1 }} />*/}
                    {/*        </View>*/}
                    {/*    )}*/}
                    {/*</>)}*/}
                </View>
            </View>

            <View
                style={{
                    marginTop: 20,
                    paddingBottom: 15,
                    marginHorizontal: 16,
                }}>
                <Button
                    variant={isLoginBtnValid ? "primary" : "disabled"}
                    disabled={!isLoginBtnValid}
                    onPress={onFormSubmit}
                    style={{ flex: globalImport.isWeb ? {} : 0 }}
                >
                    Confirm
                </Button>
            </View>
        </View>
    );
}

export default EmailBottomSheet;

const styles = StyleSheet.create({
    loginOtpErrorBar: {
        ...globalFontStyle.appFontSubText,
        color: Colors.red,
        marginTop: 20,
    },
    viewBox: {
        paddingTop: 30,
        height: "100%",
        backgroundColor: Colors.bgWhite,
        paddingHorizontal: 16,
    },
    underlineStyleBase: {
        ...globalFontStyle.appFontSubHeading,
        color: Colors.black,
        borderBottomWidth: 1,
        width: 45,
        height: 55,
        marginRight: 10,
        marginLeft: 0,
        borderRadius: 8,
        alignItems: "center",
        borderWidth: 1,
        marginVertical: 0,
    },

    underlineStyleHighLighted: {
        borderColor: Colors.tradexBlue,
    },
});
